import React, { useState,useEffect } from "react";
import { HeroText } from '../../components/';
import { HalfColText } from '../../components';
import { HalfColTextFlex } from '../../components';
import { VideoFullSection } from '../../components';
import { VideoScrollYoutube } from '../../components';
import { Loader } from '../../components';
import { RowQuotes } from '../../components';
import { BannerNews } from '../../components';
import {IndustriesIframeBlock} from '../../components';
import { BaseUrl } from "../../config";

const LandingNike = (props) => {
  const [highlightNews, sethighlightNews] = useState({});
  const [isFetching, setisFetching] = useState(true);
  const slug = "invrsions-3d-digital-twins-physically-react-to-movement"
  const imgHero = require('../../assets/hero-nike.jpg');
  const peopleArray = [
    {
      quote : "Matteo is an entrepreneur and a media and technology enthusiast. In '98 he started his first job in the communications sector and in 1999 he started his first digital consulting agency, MKTweb, working as a web designer and developer. After years of collaboration with important international agencies like Grey Interactive, Sapient, Icon Medialab, in 2004 Matteo founded Imille, a multi-awarded creative agency for emerging media. Today Imille is in the top ten Italian digital agencies, with HQ in Milano and offices in Roma, Madrid and Santiago de Chile. In 2015 he founded Invrsion. As CEO of Invrsion he's leading the international development of real-time room-scale simulations for the retail market, leveraging on his experience and network to sign global agreements with international clients and partners.",
      img : require("../../assets/avatar-landing/esposito.jpg"),
      name: "Matteo Esposito"
    },
    {
      quote : "With a degree in Industrial Design, Fabrizio has worked in video game production for more than 20 years. He lead as a supervisor at AAA Games including titles like 'MXGP', 'MOTOGP14', 'MOTOGP13', 'WRC3', 'WRC2', 'WRC1', 'MUD', 'Ruff Trigger' and 'Iridium Runners'. As an expert in 3D asset creation, he leads a large team, from environmental design and full levels creation, to guideline and graphics pipeline, up to game-ready submissions. He has dealt with various outsourcing vendors, managing asset supervision and producing industrial guidelines for the following platforms: PS4, PS3, XBOX 360, PC, WII, PSP, PSVITA. He entered Invrsion as its first employee, signing a retention plan. He is the COO and he co-signed with Invrsion's patent about the automatic 3D product digitization with Matteo Esposito. He leads the 3D content production and, as a senior Unreal Engine 3D content expert, is a key figure in ensuring the realism of Invrsion simulations.",
      img : require("../../assets/avatar-landing/dini.jpg"),
      name: "Fabrizio Dini"
    },
    {
      quote : "Ph.D. since 2012 from the Politecnico di Milano, Italy, Michele is a control engineer specialised in design and control of haptic systems. Holding two patent applications concerning a haptic direction indicator for gaming and pedestrian navigation, he has senior software skills (Software design, requirements, UML,C, C++, Java, C#, 3D graphics, OpenGL, GLSL shaders and GPGPU, CUDA, OpenCL) and mechatronics skills (control systems like PID, Fuzzy and LQR, mechatronics, robots and haptic devices, CAD tools like CATIA, ProEngineer and SolidWorks, non-CNC machining, digital circuit design, MATLAB and Simulink, National Instruments hardware and LabView, Real time control boards and DAQ. At Invrsion as CTO he leads the ShefZone® development team and every R&D project, including the development of the patent for the automatic 3D product digitization. Like Fabrizio Dini he signed a retention plan.",
      img : require("../../assets/avatar-landing/antolini.jpg"),
      name: "Michele Antolini"
    },
    {
      quote : "Katharina leads Invrsion North America. As co-founder of the world renowned Festival of Media and previously the CEO of the publicly listed specialist consultancy Centaur, Katharina brings her entrepreneurial mindset and corporate expertise to our leadership team. With digital transformation being at the heart of every endeavor, Katharina has been recognized as one of the top 35 under 35 women in business by The Times.",
      img : require("../../assets/avatar-landing/mccarthy.jpg"),
      name: "Katharina McCarthy-Pesch"
    },
    {
      quote : "Jeff Minsky leads our North America Marketing Efforts. He has brought digital innovation to the media and advertising space for over two decades. As co-founder of Ogilvy & Mather's Digital Media team, leader of Omnicom Media Group's Emerging Media team for over 15 years, and Lead Industry Analyst at MediaVillage, he has helped Fortune 100 companies innovate and adapt their marketing strategy and business infrastructure with each leap of technological advancement.",
      img : require("../../assets/avatar-landing/minsky.jpg"),
      name: "Jeff Minsky"
    }
  ]

  useEffect(() => {
    // all articles
    fetch(`${BaseUrl}/post?key=invrsion&slug=${slug}`, {
      method: 'GET',
      headers : { 
        'Accept': 'application/json'
       }
    })
    .then(response => {
      return response.json()
    }).then((json) =>  {
      sethighlightNews(json.data.single_news);
      setisFetching(false)
    })
    
    
  }, []);

  const arrayLoad = [
    imgHero
  ]

  const excerptNike = 'Invrsion accelerates industry push to modernize Fashion showrooming experience and digital commerce.'
  
  return (
    <React.Fragment>
      <HeroText 
        title="Invrsion for Nike: an introduction" 
        subtitle="Invrsion's Mission: To Wow!"
        paragraph="Invrsion’s 3D retail simulations and digital twins are simply awe-inspiring.<br><br>
        Forgive us for this little virtual humble brag, but we consistently hear feedback like, “I’ve never seen anything of this quality before”.<br><br>
        Nike’s brand screams quality and performance. The personification of that brand in Nike’s Virtual Space must reflect that level of excellence. Your buyers expect it.<br><br>
        Please peruse the following brief videos to get a better visual understanding of the quality of work that Invrsion would be honored to do for Nike."
        textBelow={true} 
        image={imgHero}
        align="right"
        isLanding={true}
      />
     
      <VideoFullSection 
        bgColor="#000000"
        title="The V-Commerce experience"
        black="#ffffff"
        noMarginBottom={true}
        zIndex={5}
        text="A visualization of a Mixed Reality experience for a clothing and sportswear retailer."
      >
        <VideoScrollYoutube 
          idScroll="video-real-01" 
          idVideo="k5YG5a5nU1k"
        />
      </VideoFullSection>
      <VideoFullSection 
        bgColor="#4D4D4D"
        title="Virtual showroom prototype video"
        black="#ffffff"
        extraTopPadding={true}
        noMarginBottom={true}
        align="right"
        zIndex={4}
        text="A showroom for fashion buyers and sellers to interact and introduce their latest collections."
      >
        <VideoScrollYoutube 
          idScroll="video-real-02" 
          align="right"
          idVideo="szjRJnyc6I8"
        />
      </VideoFullSection>

      <VideoFullSection 
        bgColor="#4D4D4D"
        title="Example of hypermarket template simulation"
        black="#ffffff"
        extraTopPadding={true}
        noMarginBottom={true}
        zIndex={3}
        text="A simulation of an immersive VR environment for a large US retailer."
      >
        <VideoScrollYoutube 
          idScroll="video-real-01" 
          idVideo="Yg9wukwL90I" 
        />
      </VideoFullSection>
      <VideoFullSection 
        bgColor="#000000"
        title="Shelfzone<span class='smaller'>®</span> user journey"
        black="#ffffff"
        extraTopPadding={true}
        extraBottom={true}
        align="right"
        zIndex={2}
        text="A glimpse of our proprietary software for building, managing, and launching virtual retail simulations."
      >
        <VideoScrollYoutube 
          idScroll="video-real-02" 
          align="right"
          idVideo="KGPmUSpulfE"
        />
      </VideoFullSection>
      <IndustriesIframeBlock 
        bgColor="#ffffff"
        url="297b6437e49c40a6b59356fbc1fc09dd"
        title="Invrsion at the Forefront of 3D Digitization"
        black="#000000"
        zoom="1600"
        isLanding={true}
        mobileSrc={require('../../assets/iframe-placeholder/jordan_resized.png')}
        text="A 3D Digital Twin of a Nike Air Jordan showcasing Invrsion’s hyper-realistic quality."
        iframeUrl="https://sketchfab.com/models/297b6437e49c40a6b59356fbc1fc09dd/embed?annotations_visible=0&amp;camera=0&amp;animation_autoplay=0&amp;autostart=0&amp;ui_controls=0&amp;ui_infos=0&amp;ui_inspector=0&amp;ui_stop=0&amp;ui_watermark=0&amp;ui_watermark_link=0&amp;preload=1&amp;scrollwheel=0&amp;sound_enable=0&amp;ui_animations=0&amp;ui_annotations=0&amp;ui_ar=0&amp;ui_fadeout=0&amp;ui_fullscreen=0&amp;ui_help=0&amp;ui_infos=0&amp;ui_inspector=0&amp;ui_settings=0&amp;ui_stop=0&amp;ui_theatre=0&amp;ui_vr=0&amp;pixel_budget=0&amp;orbit_constraint_zoom_in=1900"

      />
      {
        !isFetching &&
        <BannerNews isFetching={isFetching} highlightNews={highlightNews} excerpt={excerptNike} slug='invrsions-3d-digital-twins-physically-react-to-movement' />
      }
      <HalfColText >
        <div className="title--col">
          
        </div>
        {
          peopleArray.length > 0 &&
          <HalfColTextFlex>
            {
              peopleArray.map((key, index) => {
                return <RowQuotes key={index} quote={key.quote} name={key.name} img={key.img} isLanding={true}/>
              })
            }
          </HalfColTextFlex>
        }
      </HalfColText>
            
      <Loader arrayLoad={arrayLoad} />

    </React.Fragment>
  );
};

export default LandingNike;
